<template>
  <div>
    <v-card v-if="loading">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card-text>
            Cargando...
            <v-progress-linear
              indeterminate
              color="blue"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-layout>
      </v-container>
    </v-card>
    <v-card v-if="!loading && notFound">
      <v-alert :value="true" type="error" color="red">
        Edificio no encontrado.
      </v-alert>
    </v-card>
    <v-card v-if="!loading && !notFound" flat>
      <v-card-text v-if="!readonly">
        <GmapAutocomplete
          style="width: 100%;min-height: 30px;"
          @place_changed="setPlace"
        />
        <br />
        <v-btn
          :disabled="!metido || loadingAction"
          color="primary"
          outline
          @click="addMarker"
        >
          <v-icon dark left>mdi-map-search</v-icon>
          Buscar
        </v-btn>
      </v-card-text>
      <GmapMap
        v-if="!(!hasLocation && readonly)"
        :center="center"
        :zoom="zoom"
        :options="{
          zoomControl: true,
          mapTypeControl: true,
          scaleControl: true,
          streetViewControl: false,
          rotateControl: true,
          fullscreenControl: true,
          disableDefaultUi: false
        }"
        map-type-id="roadmap"
        style="width: auto; min-height: 500px"
      >
        <GmapMarker
          v-if="marker !== null"
          :position="marker.position"
          :clickable="true"
          :draggable="!readonly"
          @dragend="gMapFunc($event.latLng)"
          @click="center = marker.position"
        />
      </GmapMap>
      <br />
      <v-card-text v-if="marcado">
        Dirección completa: {{ datos.address }}
        <br />
        Nombre: {{ datos.name }}
        <br />
        Localidad: {{ datos.locality }}
        <br />
        Código país: {{ datos.country }}
        <br />
        Latitud: {{ datos.lat }} Longitud: {{ datos.lng }}
      </v-card-text>
      <v-card-actions v-if="!readonly">
        <v-btn
          color="primary"
          :loading="loadingAction"
          :disabled="deshabilitarMod"
          @click="agregarUbicacion"
        >
          <v-icon dark left>mdi-map-marker-plus</v-icon>
          {{ titulo }}
        </v-btn>
        <v-btn
            color="red"
            dark
            :loading="loadingAction"
            :disabled="!hasLocation"
            v-if="hasLocation"
            @click="borrarUbicacion"
        >
          <v-icon dark left>mdi-map-marker-minus</v-icon>
          Borrar ubicación
        </v-btn>
      </v-card-actions>
      <v-alert
          :value="exito"
          type="success"
          dismissible
      >
        Ubicación cambiada con éxito.
      </v-alert>
      <v-alert
          :value="exitoBorrado"
          type="success"
          dismissible
      >
        Ubicación borrada con éxito.
      </v-alert>
    </v-card>
  </div>
</template>

<script>
import firebase from "firebase";

let firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
    authDomain: "tfgr-9ed26.firebaseapp.com",
    databaseURL: "https://tfgr-9ed26.firebaseio.com",
    projectId: "tfgr-9ed26",
    storageBucket: "tfgr-9ed26.appspot.com",
    messagingSenderId: "47742064305"
  });
} else {
  firebaseApp = firebase.app();
}

// Export the database for components to use.
// If you want to get fancy, use mixins or provide / inject to avoid redundant imports.
export const db = firebaseApp.database();

//Menú para añadir ubicación a un edificio
// @group Configurar edificio
export default {
  name: "AddLocation",
  props: {
    //ID del edificio
    idKey: {
      default: "",
      type: String
    },
    //Si no se puede editar el mapa
    readonly: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      loading: true,
      loadingAction: false,
      center: { lat: 40, lng: -3 },
      zoom: 5,
      marker: null,
      places: [],
      currentPlace: null,
      marcado: false,
      metido: false,
      exito: false,
      exitoBorrado: false,
      datos: {
        address: "",
        name: "",
        locality: "",
        country: "",
        lat: "",
        lng: ""
      }
    };
  },
  created() {
    this.$bindAsArray(
      "vectorObjecto",
      db
        .ref("buildings")
        .orderByChild("key")
        .equalTo(this.idKey)
        .limitToFirst(1),
      snap => {
        if (!(
          this.vectorObjecto.length === 0 ||
          this.vectorObjecto[0] === null ||
          this.vectorObjecto[0] === undefined ||
          this.vectorObjecto[0].location === null ||
          this.vectorObjecto[0].location === undefined
        )) {
          this.datos = Object.assign({}, this.vectorObjecto[0].location);
          const marker = {
            lat: this.datos.lat,
            lng: this.datos.lng
          };
          this.marker = { position: marker };
          this.center = marker;
          this.marcado = true;
          this.zoom = 18;
        }
        this.loading = false;
      },
      error => {
        if (!(
          this.vectorObjecto.length === 0 ||
          this.vectorObjecto[0] === null ||
          this.vectorObjecto[0] === undefined ||
          this.vectorObjecto[0].location === null ||
          this.vectorObjecto[0].location === undefined
        )) {
          this.datos = Object.assign({}, this.vectorObjecto[0].location);
          const marker = {
            lat: this.datos.lat,
            lng: this.datos.lng
          };
          this.marker = { position: marker };
          this.center = marker;
          this.marcado = true;
          this.zoom = 18;
        }
        this.loading = false;
      }
    );
  },
  mounted() {
    if (!this.hasLocation) {
      this.geolocate();
    }
  },
  methods: {
    emitToParent() {
      // Se lanza cuando se añade la ubicación
      this.$emit("locationAdded", true);
    },
    // @vuese
    // Recoge la posición indicada por la chincheta en el mapa
    // @arg Posición
    gMapFunc(evnt) {
      this.marker.position = { lat: evnt.lat(), lng: evnt.lng() };
      this.datos.lat = this.marker.position.lat;
      this.datos.lng = this.marker.position.lng;
    },
    // @vuese
    // Cambia la ubicación del edificio
    // @arg Edificio y ubicación
    agregarUbicacion() {
      this.exito = false;
      this.exitoBorrado = false;
      this.loadingAction = true;
      let self = this;
      this.$store
        .dispatch("changeLocation", {
          key: this.idKey,
          location: this.datos
        })
        .then(function() {
          self.loadingAction = false;
          self.emitToParent();
          self.exito = true;
        })
        .catch(error => {
          self.loadingAction = false;
          self.emitToParent();
          self.exito = true;
        });
    },
    // @vuese
    // Borra la ubicación del edificio
    // @arg Edificio
    borrarUbicacion() {
      this.exito = false;
      this.exitoBorrado = false;
      if (confirm("¿Estás seguro de que quieres borrar la ubicación?")) {
        this.loadingAction = true;
        let self = this;
        this.$store
          .dispatch("removeLocation", {
            key: this.idKey
          })
          .then(function () {
            self.loadingAction = false;
            self.exitoBorrado = true;
          })
          .catch(error => {
            self.loadingAction = false;
            self.exitoBorrado = true;
          });
      }
    },
    // @vuese
    // Recibe un lugar del buscador
    // @arg Lugar
    setPlace(place) {
      this.metido = place.name !== "";
      this.currentPlace = place;
    },
    // @vuese
    // El usuario selecciona un lugar en el mapa
    // @arg Lugar
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.marker = { position: marker };
        this.places[0] = this.currentPlace;
        this.center = marker;
        this.currentPlace = null;

        let country = "";
        let locality = "";
        for (let i = 0; i < this.places[0].address_components.length; i++) {
          let found = this.places[0].address_components[i].types.findIndex(
            function(element) {
              return element === "country";
            }
          );
          if (found !== -1) {
            country = this.places[0].address_components[i].short_name;
            break;
          }
        }
        for (let i = 0; i < this.places[0].address_components.length; i++) {
          let found = this.places[0].address_components[i].types.findIndex(
            function(element) {
              return element === "locality" || element === "postal_town";
            }
          );
          if (found !== -1) {
            locality = this.places[0].address_components[i].long_name;
            break;
          }
        }
        if (locality === "") {
          locality = this.places[0].vicinity;
        }
        this.datos = {
          address: this.places[0].formatted_address,
          name: this.places[0].name,
          locality: locality,
          country: country,
          lat: this.marker.position.lat,
          lng: this.marker.position.lng
        };
        this.marcado = true;
        return this.sameData;
      }
    },
    // @vuese
    // Centra la vista del usuario en su ubicación cuando este la comparte al sistema
    // @arg Localización del usuario
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.zoom = 15;
      });
    }
  },
  computed: {
    // @vuese
    // Deshabilita el botón de guardar cambios si no hay cambios
    deshabilitarMod() {
      return !this.marcado || this.sameData;
    },
    // @vuese
    // Comprueba si ha habido cambios
    sameData() {
      if (!this.hasLocation) {
        return false;
      }
      return (
        this.vectorObjecto[0].location.address === this.datos.address &&
        this.vectorObjecto[0].location.name === this.datos.name &&
        this.vectorObjecto[0].location.locality === this.datos.locality &&
        this.vectorObjecto[0].location.lat === this.datos.lat &&
        this.vectorObjecto[0].location.lng === this.datos.lng &&
        this.vectorObjecto[0].location.country === this.datos.country
      );
    },
    // @vuese
    // Indica si el edificio no ha sido encontrado
    notFound() {
      if (
        this.vectorObjecto === null ||
        this.vectorObjecto === undefined ||
        this.vectorObjecto.length === 0 ||
        this.vectorObjecto[0] === null ||
        this.vectorObjecto[0] === undefined
      ) {
        return true;
      } else {
        return false;
      }
    },
    // @vuese
    // Indica si el edificio tiene ubicación
    hasLocation() {
      if (
        this.loading ||
        this.vectorObjecto === null ||
        this.vectorObjecto === undefined
      ) {
        return false;
      }
      if (
        this.vectorObjecto.length === 0 ||
        this.vectorObjecto[0] === null ||
        this.vectorObjecto[0] === undefined ||
        this.vectorObjecto[0].location === null ||
        this.vectorObjecto[0].location === undefined
      ) {
        return false;
      } else {
        return true;
      }
    },
    // @vuese
    // Cambia el título del botón de guardar en función de si hay ubicación o no.
    titulo() {
      if (this.hasLocation) {
        return "Modificar ubicación";
      } else {
        return "Agregar ubicación";
      }
    }
  }
};
</script>

<style scoped>
input {
  border: 2px solid rgba(0, 0, 0, 0.54);
  border-radius: 4px;
  padding: 0 12px;
  margin: 6px 8px;
}
</style>
